// extracted by mini-css-extract-plugin
export default {"name":"HoSoDetail_name__lj4yS","info-box":"HoSoDetail_info-box__o5QHS","circle":"HoSoDetail_circle__eca98","thanh-tich-title":"HoSoDetail_thanh-tich-title__NT3hZ"};